export default "__VITE_ASSET__DUPi3z5C__"